import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../baseQuery';

export const parentApi = createApi({
	reducerPath: 'parentApi',
	baseQuery: axiosBaseQuery,
	tagTypes: ['ParentDashboard', 'ParentChildren', 'ChildSessions'],
	endpoints: (builder) => ({
		getParentDashboard: builder.query<any, void>({
			query: () => ({ url: '/parent/dashboard' }),
			providesTags: ['ParentDashboard'],
		}),
		getChildren: builder.query<any, void>({
			query: () => ({ url: '/parent/children' }),
			providesTags: ['ParentChildren'],
		}),
		getChildSessions: builder.query<any, { childId: string; skip?: number }>({
			query: ({ childId, skip = 0 }) => ({
				url: `/parent/child/${childId}/sessions?skip=${skip}`,
			}),
			providesTags: (_result, _err, { childId }) => [
				{ type: 'ChildSessions', id: childId },
			],
		}),
		switchChild: builder.mutation<any, string>({
			query: (childId) => ({
				url: `/parent/child/${childId}/switch`,
				method: 'POST',
			}),
			invalidatesTags: ['ParentDashboard'],
		}),
		getChildAnalytics: builder.query<any, string>({
			query: (childId) => ({
				url: `/parent/child/${childId}/analytics`,
			}),
		}),
		getChildSessionReview: builder.query<
			any,
			{ childId: string; sessionId: string }
		>({
			query: ({ childId, sessionId }) => ({
				url: `/parent/child/${childId}/sessions/${sessionId}/review`,
			}),
		}),
		getChildCurriculumProgress: builder.query<any, string>({
			query: (childId) => ({
				url: `/parent/child/${childId}/curriculum-progress`,
			}),
		}),
	}),
});

export const {
	useGetParentDashboardQuery,
	useGetChildrenQuery,
	useGetChildSessionsQuery,
	useSwitchChildMutation,
	useGetChildAnalyticsQuery,
	useGetChildSessionReviewQuery,
	useGetChildCurriculumProgressQuery,
} = parentApi;
